export default __webpack_public_path__ + "static/media/icon-website.0d7a03b7.svg";